// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ulBi","questions":"styles_questions__1O4ty","footer":"styles_footer__3VeUG"};